export const INITIAL_ZOOM = 1000;
export const ZOOM_DECREASE = 225;
export const MIN_ZOOM = 100;
export const WIN_MODAL_DELAY = 1200;
export const ERROR_DISPLAY_TIME = 2000;
export const COUNTDOWN_TIME = 5;
export const DEFAULT_FREE_SKIPS = 3;
export const DEFAULT_FREE_INSPECTS = 3;
// Guests can complete up to this many Unlimited games per UTC day.
export const GUEST_DAILY_GAME_LIMIT = 3;
export const GUEST_DAILY_FREE_INSPECTS = 2;
export const GUEST_DAILY_FREE_ZOOM_OUTS = 2;
export const INSPECT_COST = 100;
export const RIDDLE_COST = 200;
export const ZOOM_OUT_PREVIEW_MS = 120;
// Guest zoom-out has no network latency, so use a longer preview to match perceived timing.
export const GUEST_ZOOM_OUT_PREVIEW_MS = 1050;
// Easy riddles intentionally cost more (server enforces this too).
export const RIDDLE_EASY_BONUS = 100;
export const RIDDLE_REPEAT_INCREMENT = 50;
// Riddles are slightly more expensive early in the round (first two guess rows).
export const RIDDLE_EARLY_GUESS_SURCHARGE = 50;
export const DEFAULT_STATS = {
  guesses: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
  losses: 0,
  currentStreak: 0,
  maxStreak: 0,
};

export const INITIAL_GAME_STATE = {
  solution: '',
  imageUrl: '',
  imageSource: null,
  imageId: null,
  guesses: Array(5).fill(''),
  currentGuess: '',
  currentRow: 0,
  gameOver: false,
  zoomLevel: INITIAL_ZOOM,
  // Random origin for the zoom offset (generated per round). null = center.
  zoomOrigin: null,
  loading: false,
  isTransitioning: false,
  isChecking: false,
  isRequestPending: false,
};
